module.exports = __webpack_public_path__ + "static/media/49.d2069bbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/49.jpg
// module id = 739
// module chunks = 0